import { checkResponse } from "src/components/js/statics1";

export async function dailyMessageBoxesGetByAsiakasId(asiakasId, aika, token, yyyymmdd) {
  if (!asiakasId || !aika || !token) return false;
  const addr = "/api/dailyMessage/box/list/" + asiakasId;
  const fullUrl = import.meta.env.VITE_SERVER_URL + addr;
  const requestOptions = {
    method: "POST",
    headers: {
      "x-access-token": `${token}`,
      "Content-Type": "application/json",
    },
    body: JSON.stringify({ aika: aika, yyyymmdd: yyyymmdd }),
  };
  const response = await fetch(fullUrl, requestOptions);
  const cResponse = await checkResponse(
    response,
    "dailyMessageFunctions:dailyMessageBoxesGetByAsiakasId"
  );
  if (!cResponse.success) return false;
  return cResponse.data;
}

export async function dailyMessageBox_addBox(ownerAsiakasId, yyyymmdd, token) {
  const fullUrl = import.meta.env.VITE_SERVER_URL + "/api/dailyMessage/box/add/" + yyyymmdd;
  const requestOptions = {
    method: "POST",
    headers: {
      "x-access-token": `${token}`,
      "Content-Type": "application/json",
    },
    body: JSON.stringify({ ownerAsiakasId: ownerAsiakasId, yyyymmdd: yyyymmdd }),
  };
  const response = await fetch(fullUrl, requestOptions);
  return response.ok;
}

export async function dailyMessageBox_deleteBox(boxId, token) {
  const fullUrl = import.meta.env.VITE_SERVER_URL + "/api/dailyMessage/box/delete/" + boxId;
  const requestOptions = {
    method: "DELETE",
    headers: {
      "x-access-token": `${token}`,
      "Content-Type": "application/json",
    },
  };
  const response = await fetch(fullUrl, requestOptions);
  return response.ok;
}
export async function dailyMessageBox_deleteAsiakas(dailyMessageBoxAsiakasId, token) {
  const fullUrl =
    import.meta.env.VITE_SERVER_URL +
    "/api/dailyMessage/box/asiakas/delete/" +
    dailyMessageBoxAsiakasId;
  const requestOptions = {
    method: "DELETE",
    headers: {
      "x-access-token": `${token}`,
      "Content-Type": "application/json",
    },
  };
  const response = await fetch(fullUrl, requestOptions);
  return response.ok;
}

export async function dailyMessageBox_saveBox(box, token) {
  const fullUrl = import.meta.env.VITE_SERVER_URL + "/api/dailyMessage/box/save";
  const requestOptions = {
    method: "POST",
    headers: {
      "x-access-token": `${token}`,
      "Content-Type": "application/json",
    },
    body: JSON.stringify(box),
  };
  const response = await fetch(fullUrl, requestOptions);
  return response.ok;
}

export async function dailyMessageBox_addAsiakas(boxId, asiakasId, token) {
  const fullUrl = import.meta.env.VITE_SERVER_URL + "/api/dailyMessage/box/asiakas/add";
  const requestOptions = {
    method: "POST",
    headers: {
      "x-access-token": `${token}`,
      "Content-Type": "application/json",
    },
    body: JSON.stringify({ boxId: boxId, asiakasId: asiakasId }),
  };
  const response = await fetch(fullUrl, requestOptions);
  return response.ok;
}

//  @boxId int,
//  @asiakasPersonSettingTypeId int,
//   @asiakasId int,
//   @dailyMessageBoxAsiakasId int

export async function dailyMessageBox_addAsiakasPermission(
  boxId,
  asiakasPersonSettingTypeId,
  asiakasId,
  dailyMessageBoxAsiakasId,
  token
) {
  const fullUrl = import.meta.env.VITE_SERVER_URL + "/api/dailyMessage/box/asiakas/permission/add";
  const requestOptions = {
    method: "POST",
    headers: {
      "x-access-token": `${token}`,
      "Content-Type": "application/json",
    },
    body: JSON.stringify({
      boxId: boxId,
      asiakasPersonSettingTypeId: asiakasPersonSettingTypeId,
      asiakasId: asiakasId,
      dailyMessageBoxAsiakasId: dailyMessageBoxAsiakasId,
    }),
  };
  const response = await fetch(fullUrl, requestOptions);
  return response.ok;
}
export async function dailyMessageBox_deleteAsiakasPermission(
  dailyMessageBoxAsiakasPermissionId,
  token
) {
  const fullUrl =
    import.meta.env.VITE_SERVER_URL +
    "/api/dailyMessage/box/asiakas/permission/delete/" +
    dailyMessageBoxAsiakasPermissionId;
  const requestOptions = {
    method: "DELETE",
    headers: {
      "x-access-token": `${token}`,
      "Content-Type": "application/json",
    },
  };
  const response = await fetch(fullUrl, requestOptions);
  return response.ok;
}

export async function dailyMessageBox_saveAsiakasPermission(asiakasPermission, token) {
  const fullUrl = import.meta.env.VITE_SERVER_URL + "/api/dailyMessage/box/asiakas/permission/save";
  const requestOptions = {
    method: "POST",
    headers: {
      "x-access-token": `${token}`,
      "Content-Type": "application/json",
    },
    body: JSON.stringify(asiakasPermission),
  };
  const response = await fetch(fullUrl, requestOptions);
  return response.ok;
}

export async function dailyMessageBox_saveMessage(boxId, message, yyyymmdd, token) {
  const fullUrl = import.meta.env.VITE_SERVER_URL + "/api/dailyMessage/box/message/save";
  const requestOptions = {
    method: "POST",
    headers: {
      "x-access-token": `${token}`,
      "Content-Type": "application/json",
    },
    body: JSON.stringify({ boxId: boxId, message: message, yyyymmdd: yyyymmdd }),
  };
  const response = await fetch(fullUrl, requestOptions);
  return response.ok;
}
